import React, { Component } from 'react';
import styled from 'styled-components';

import theme from '../styles/theme';
import { stylesFor } from '../styles/utilities';

const Root = styled.div`
  background: ${props =>
    props.background ? props.background : theme.color.white};
  color: ${props => (props.foreground ? props.foreground : theme.color.gray19)};
  display: flex;
  justify-content: center;
`;

const Content = styled.div`
  flex-grow: 1;
  max-width: 1600px;
  padding: 40px 20px;

  ${stylesFor.mediumUp`
    padding: 80px 60px;
  `};
`;

export default class Section extends Component {
  render() {
    return (
      <Root
        foreground={this.props.foreground}
        background={this.props.background}
        style={this.props.style}
      >
        <Content className={this.props.className}>
          {this.props.children}
        </Content>
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/section.js